var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.libraryCoach)?_c('coach-required'):_c('evaluations-view',{key:_vm.libraryCoach.id})
}
var staticRenderFns = []

export { render, staticRenderFns }